
import { defineComponent, type PropType } from "vue-demi";
import { declination } from "@artmizu/utils";
import { utcToZonedTime } from "date-fns-tz";

export default defineComponent({
  name: "GGTimerBlock",
  props: {
    /**
     * Формат времени '2020-11-26T00:00:00'
     */
    time: {
      type: String as PropType<string | null>,
      default: null,
    },
    /**
     * Цвет таймера
     * Поддерживаемые значения: 'red', 'black'
     */
    color: {
      type: String as PropType<string>,
      default: "black",
      validator(el) {
        return ["red", "black"].some((item) => item === el);
      },
    },
    /**
     * Размер таймера
     * Поддерживаемые значения: 's', 'm', 'l'
     */
    size: {
      type: String as PropType<string>,
      default: "s",
      validator(el) {
        return ["s", "m", "l"].some((item) => item === el);
      },
    },
  },
  data(): {
    dateTo: number | null;
    timer: number | null;
    interval: {
      days: number;
      hours: number;
      minutes: number;
    };
    ended: boolean;
  } {
    return {
      dateTo: null,
      timer: null,
      interval: {
        days: 0,
        hours: 0,
        minutes: 0,
      },
      ended: false,
    };
  },
  computed: {
    formattedDays() {
      const count =
        this.interval.days < 10 ? `0${this.interval.days}` : this.interval.days;
      const text = declination(this.interval.days, ["день", "дня", "дней"]);
      return { count, text };
    },
    formattedHours() {
      const count =
        this.interval.hours < 10
          ? `0${this.interval.hours}`
          : this.interval.hours;
      const text = declination(this.interval.hours, ["час", "часа", "часов"]);
      return { count, text };
    },
    formattedMinutes() {
      const count =
        this.interval.minutes < 10
          ? `0${this.interval.minutes}`
          : this.interval.minutes;
      const text = declination(this.interval.minutes, [
        "минута",
        "минуты",
        "минут",
      ]);
      return { count, text };
    },
  },
  mounted() {
    this.initializeTimer();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    initializeTimer() {
      if (this.time && typeof this.time === "string") {
        this.dateTo = Date.parse(this.time);
        this.update();
        this.timer = setInterval(
          () => this.update(),
          1000 * 60
        ) as unknown as number;
      } else {
        this.end();
      }
    },
    update() {
      const difference = this.dateTo
        ? this.dateTo - +utcToZonedTime(Date.now(), "Europe/Moscow")
        : 0;

      if (difference > 0) {
        this.interval = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
        };
      } else {
        this.end();
      }
    },
    end() {
      this.ended = true;
      this.$emit("end");
      if (this.timer) clearInterval(this.timer);
    },
  },
});
